/**
 * User: Rob Richard
 * Date: 5/5/15
 * Time: 7:20 PM
 */

'use strict';

var braintree;
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}

module.exports = {
    checkout: function (clientToken, options) {
        return braintree.setup(clientToken, 'paypal', options);
    },
    /**
     * Takes a paypalData object from braintree and transforms it into an object
     * representing a backend PayPalAccount model
     * @param paypalData
     * @returns {{nonce: *, firstName: *, lastName: *, email: *, billingAddress: {city: *, country: (exports.displayLabels.countryCode|*|exports.displayTransforms.countryCode), line1: (*|mockUS.line1|mockNonUS.line1|UserProfile.displayLabels.line1|exports.displayLabels.line1|line1), line2: (*|mockUS.line2|mockNonUS.line2|UserProfile.displayLabels.line2|exports.displayLabels.line2|line2), zipCode: (.billingAddress.postalCode|*), state: *}}}
     */
    getPayPalModelData: function (paypalData) {
        var details;
        var billingAddress;
        paypalData = paypalData || {};
        details = paypalData.details || {};
        billingAddress = details.billingAddress || {};
        return {
            nonce: paypalData.nonce,
            firstName: details.firstName,
            lastName: details.lastName,
            email: details.email,
            billingAddress: {
                city: billingAddress.locality,
                country: billingAddress.countryCodeAlpha2,
                line1: billingAddress.streetAddress,
                line2: billingAddress.extendedAddress,
                zipCode: billingAddress.postalCode,
                state: billingAddress.region
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/paypal.js
// module id = 170
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55